<template>
  <div>
    <!-- Mostrar mensaje si aún no cargó -->
    <div v-if="cargando">Cargando ...</div>

    <!-- Mostrar tablas -->
    <div v-else>
      <CrearProductoDialog
        :key="dialogKey"
        :mostrar.sync="dialogNuevoProducto"
        :gridSeleccionado="gridSeleccionado"
        :cliente="auditoria?.cliente || null"
        :auditoriaUuid="auditoria.uuid"
        :producto="productoEditando"
        @guardado="emitirProductoGuardado" />

      <!-- botón añadir -->
      <v-btn v-if="!esVistaRevision && estadoAuditoria!=='CERRADA'" color="primary" class="mb-4" @click="dialogElegirModo = true"> {{ $t('productosAuditoria.addProduct') }} </v-btn>

      <!-- Dialog 1: Elegir modo -->
      <v-dialog v-model="dialogElegirModo" max-width="400px">
        <v-card>
          <v-card-title class="text-h6">Añadir producto</v-card-title>

          <v-card-text>
            <v-btn block color="primary" @click="elegirNuevo"> Añadir nuevo </v-btn>

            <v-btn block color="secondary" class="mt-3" @click="elegirIteracion">
              Desde iteración
            </v-btn>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogElegirModo = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog 2: Elegir GRID -->
      <v-dialog v-model="dialogElegirGrid" max-width="500px">
        <v-card>
          <v-card-title class="text-h6">Seleccione el Alcance</v-card-title>

          <v-card-text>
            <v-list two-line>
              <v-list-item
                v-for="grid in gridsAlcance"
                :key="grid.uuid"
                @click="seleccionarGrid(grid)">
                <v-list-item-content>
                  <v-list-item-title>{{ grid.nombre }}</v-list-item-title>
                  <v-divider></v-divider>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogElegirGrid = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      
      <!-- Dialog 3: Elegir producto -->
      <v-dialog v-model="dialogElegirProducto" max-width="100vw" width="80%" persistent>
        <v-card>
          <v-card-title class="text-h6">Seleccione el producto</v-card-title>

          <SelectEmplazamientoProductos
            :valueEmplazamientos.sync="selected_emplazamiento"
            :valueProductos.sync="selected_productos"
            :productos="productosPendientesIteracion"
            :subalcance="auditoria.subalcance"
            :grupos-config="auditoria.gruposConfig"
          />

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :disabled="guardandoDesdeIteracion" @click="dialogElegirProducto = false">
              Cancelar
            </v-btn>

            <v-btn
              color="primary"
              :loading="guardandoDesdeIteracion"
              :disabled="guardandoDesdeIteracion || !selected_productos.length"
              @click="guardarProductosDesdeIteracion"
            >
              Guardar seleccionados ({{ selected_productos.length }})
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG 4 : Eliminar producto -->
      <v-dialog v-model="dialogEliminarProducto" max-width="500px" persistent>
        <v-card>
          <v-card-title class="text-h6">
            Eliminar producto
          </v-card-title>

          <v-card-text>
            <v-checkbox
              v-model="opcionesEliminar.auditoria"
              label="Eliminar en auditoría"
              @change="onToggleEliminar('auditoria')"
            />

            <v-checkbox
              v-model="opcionesEliminar.iteracion"
              label="Eliminar en iteración"
              @change="onToggleEliminar('iteracion')"
            />

            <v-checkbox
              v-model="opcionesEliminar.ambos"
              label="Eliminar en ambos"
              @change="onToggleEliminar('ambos')"
            />

            <v-alert
              type="info"
              dense
              text
              class="mt-3"
            >
              {{ $t('bannerMessages.productProcessingInfo') }}
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer />

            <v-btn text @click="dialogEliminarProducto = false">
              Cancelar
            </v-btn>

            <v-btn
              color="red"
              :disabled="!hayOpcionSeleccionada"
              @click="confirmarEliminarProducto"
            >
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div v-for="grid in gridsAlcance" :key="grid.uuid" class="mb-10">
        <h3 class="text-h6 font-weight-bold mb-4">
          {{ grid.nombre === 'Datos de Marca' ? $t('productosAuditoria.brandData') : grid.nombre }}
        </h3>

        <TablaProductosGrid
          :grid-config="grid.gridConfig"
          :productos="productosPorGrid[grid.uuid]"
          :esVistaRevision="esVistaRevision"
          :estadoAuditoria="estadoAuditoria"
          @editar-producto="editarProducto(grid, $event)"
          @eliminar-producto="abrirDialogEliminar"
        />
      </div>

      <div v-if="gridsAlcance.length === 0">
        <em>No hay grids que definan alcance.</em>
      </div>
    </div>
  </div>
</template>

<script>
import TablaProductosGrid from './TablaProductosGrid.vue'
import CrearProductoDialog from './CrearProductoDialog.vue'
import SelectEmplazamientoProductos from './SelectEmplazamientoProductos.vue'

export default {
  name: 'ProductosAuditoria',

  components: { TablaProductosGrid, CrearProductoDialog, SelectEmplazamientoProductos },

  props: {
    auditoria: { type: Object, required: true },
    subalcance: { type: Object, required: true },
    esVistaRevision: { type: Boolean, required: true },
    estadoAuditoria: { type: String, required: true },
  },

  data() {
    return {
      productoAEliminar: null,

      dialogEliminarProducto: false,

      opcionesEliminar: {
        auditoria: false,
        iteracion: false,
        ambos: false,
      },
      cargando: true,
      productoEditando: null,
      productosLocales: [],

      // datos de configuración
      grupos: [],
      configs: [],

      // diálogos
      dialogElegirModo: false,
      dialogElegirGrid: false,
      dialogNuevoProducto: false,
      dialogElegirProducto: false,

      // selección
      gridSeleccionado: null,

      selected_emplazamiento: [],
      selected_productos: [],
      productosIteracion: [],
      iteracion: null,
      guardandoDesdeIteracion: false,
    }
  },

  computed: {
    dialogKey() {
      const grid = this.gridSeleccionado?.uuid || 'nogrid'
      const prod = this.productoEditando?.uuid || 'new'
      const open = this.dialogNuevoProducto ? 'open' : 'closed'
      return `${open}-${grid}-${prod}`
    },
    productosPendientesIteracion() {
      if (!this.iteracion?.productos?.length) return []

      // clonamos para no mutar el original
      let productos = [...this.iteracion.productos]

      for (const prodLocal of this.productosLocales || []) {
        // 1️⃣ buscar el producto "auditoría" dentro de la iteración
        const prodAuditoriaEnIteracion = productos.find(
          p => p.uuid === prodLocal.uuid
        )

        if (!prodAuditoriaEnIteracion) continue

        const gridUuid =
          prodAuditoriaEnIteracion.emplazamiento?.subalcanceConfig?.uuid
        const direccionUuid =
          prodAuditoriaEnIteracion.emplazamiento?.direccion?.uuid

        if (!gridUuid || !direccionUuid) continue

        // 2️⃣ buscar el producto ORIGINAL de iteración equivalente
        const indexIteracionOriginal = productos.findIndex(p =>
          p.origenModulo === 'iteraciones' &&
          p.emplazamiento?.subalcanceConfig?.uuid === gridUuid &&
          p.emplazamiento?.direccion?.uuid === direccionUuid
        )

        // 3️⃣ eliminarlo
        if (indexIteracionOriginal !== -1) {
          productos.splice(indexIteracionOriginal, 1)
        }
      }

      // 4️⃣ eliminar los productos de auditoría
      return productos.filter(p => p.origenModulo === 'iteraciones')
    },
    gridsAlcance() {
      const grids = new Map()

      // 1️⃣ crear grids base (tipo=grid && defineAlcance)
      this.configs
        .filter(cfg => cfg.tipo === 'grid' && cfg.defineAlcance === true)
        .forEach(cfg => {
          grids.set(cfg.uuid, {
            uuid: cfg.uuid,
            nombre: cfg.nombre,
            codigoGrid: cfg.uuid,
            gridConfig: (cfg.gridConfig || []).filter(
              col => col.define_alcance === true
            ), // columnas propias que definen alcance
            orden: cfg.orden ?? 9999,
          })
        })

      // 2️⃣ añadir configs NO grid que definen alcance
      this.configs
        .filter(cfg => cfg.tipo !== 'grid' && cfg.defineAlcance === true)
        .forEach(cfg => {
          const targets = cfg.gruposDondeDefineAlcance || []

          grids.forEach(grid => {
            if (targets.includes('all') || targets.includes(grid.uuid))
            {
              grid.gridConfig.push({
                nombre: cfg.nombre,
                tipo: cfg.tipo,
                orden: cfg.orden ?? 9999,
                estatico: cfg.estatico || null,
                subalcanceConfigUuid: cfg.uuid,
                define_alcance: true,
              })
            }
          })
        })

      // 3️⃣ ordenar columnas dentro de cada grid
      grids.forEach(grid => {
        grid.gridConfig.sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0))
      })

      // 4️⃣ devolver grids ordenados
      return Array.from(grids.values()).sort(
        (a, b) => (a.orden ?? 0) - (b.orden ?? 0)
      )
    },

    productosPorGrid() {
      const mapa = {}

      if (!this.productosLocales) return mapa
      //console.log('productosLocales',this.productosLocales)
      for (const grid of this.gridsAlcance) {
        mapa[grid.uuid] = this.productosLocales.filter(
          p => p?.tipo === grid.nombre && p.defineAlcance!==false
        )
      }
      return mapa
    },
  },

  async created() {
    await this.cargarGrupos()
    await this.cargarConfigs()
    await this.cargarProductos()
    this.cargando = false
  },

  methods: {
    async cargarProductosIteracion() {
      const iteracion = await this.$store.dispatch(
        'expedientes/iteracion',
        this.auditoria.iteracion.uuid
      )
      this.iteracion = iteracion
    },
    editarProducto(grid, producto) {
      this.gridSeleccionado = grid
      this.productoEditando = producto
      this.dialogNuevoProducto = true
    },
    async cargarProductos() {
      const res = await this.$axios.$get(
        `/productos?auditoria.uuid=${this.auditoria.uuid}`
      )
      this.productosLocales = res['hydra:member'] || []
    },
    async cargarGrupos() {
      const res = await this.$axios.$get(`/grupo_configs?subalcance.uuid=${this.subalcance.uuid}`)
      this.grupos = res['hydra:member'] || []
    },

    async cargarConfigs() {
      this.configs = []
      for (const grupo of this.grupos) {
        const res = await this.$axios.$get(`/subalcance_configs?grupo.uuid=${grupo.uuid}`)
        this.configs.push(...(res['hydra:member'] || []))
      }
      //console.log('los subalcanceConfig aqui',this.configs)
    },

    elegirNuevo() {
      this.dialogElegirModo = false
      this.dialogElegirGrid = true
    },

    async elegirIteracion() {
      this.dialogElegirModo = false
      if (!this.iteracion) {
        await this.cargarProductosIteracion()
      }
      this.dialogElegirProducto = true
    },

    seleccionarGrid(grid) {
      this.gridSeleccionado = grid
      this.dialogElegirGrid = false
      this.dialogNuevoProducto = true
      this.productoEditando = null
    },

    async emitirProductoGuardado() {
      const accion = this.productoEditando ? 'edicion' : 'alta'
      await this.cargarProductos()
      this.$emit('producto-guardado', { accion })
    },
    normalizarParamsProducto(producto) {
      const params = Array.isArray(producto?.params) ? producto.params : []

      return params.map(p => {
        const valorArray = Array.isArray(p.valor) ? p.valor : [p.valor]

        return {
          nombre: p.nombre,
          valor: valorArray,
          multiple: Array.isArray(p.valor) ? (p.multiple ?? true) : (p.multiple ?? false),
          displayValue: p.displayValue ?? (Array.isArray(valorArray) ? valorArray.join(', ') : String(valorArray ?? '')),
          tipo: p.tipo || 'character',
        }
      })
    },

    payloadCrearDesdeIteracion(producto) {
      return {
        auditoria: this.auditoria.uuid,
        direccionUuid: producto?.emplazamiento?.direccion?.uuid,
        gridUuid: producto?.emplazamiento?.subalcanceConfig?.uuid,
        params: this.normalizarParamsProducto(producto),
        productoReferencia: producto.uuid,
      }
    },

    async guardarProductosDesdeIteracion() {
      if (!this.selected_productos?.length) return

      this.guardandoDesdeIteracion = true

      try {
        // 1) construir payloads
        const payloads = this.selected_productos.map(p => this.payloadCrearDesdeIteracion(p))

        // 2) validación mínima (evitar payload roto)
        const invalidos = payloads.filter(pl => !pl.gridUuid || !pl.direccionUuid)
        if (invalidos.length) {
          this.$store.commit('notification/show', {
            text: this.$t('bannerMessages.productsMissingGridOrAddress'),
            color: 'error',
          })
          return
        }

        // 3) crear uno por uno
        for (const payload of payloads) {
          await this.$axios.$post('auditorias/crearProducto', payload)
        }

        // 4) refrescar y cerrar
        await this.cargarProductos()
        await this.cargarProductosIteracion()

        this.selected_productos = []
        this.selected_emplazamiento = []
        this.dialogElegirProducto = false

        this.$store.commit('notification/show', {
          text: this.$t('bannerMessages.productsAdded'),
          color: 'success',
        })

        this.$emit('producto-guardado', { accion: 'alta' })
      } catch (error) {
        const status = error.response?.status

        this.$store.commit('notification/show', {
          text: status === 422
            ? (error.response?.data?.['hydra:description'] || this.$t('bannerMessages.invalidData'))
            : this.$t('bannerMessages.productsAddError'),
          color: 'error',
        })
      } finally {
        this.guardandoDesdeIteracion = false
      }
    },

    abrirDialogEliminar(producto) {
      this.productoAEliminar = producto

      // reset opciones
      this.opcionesEliminar = {
        auditoria: false,
        iteracion: false,
        ambos: false,
      }

      this.dialogEliminarProducto = true
    },

    onToggleEliminar(tipo) {
      if (tipo === 'ambos' && this.opcionesEliminar.ambos) {
        this.opcionesEliminar.auditoria = false
        this.opcionesEliminar.iteracion = false
      }

      if ((tipo === 'auditoria' || tipo === 'iteracion') && this.opcionesEliminar[tipo]) {
        this.opcionesEliminar.ambos = false
      }
    },

    hayOpcionSeleccionada() {
      return (
        this.opcionesEliminar.auditoria ||
        this.opcionesEliminar.iteracion ||
        this.opcionesEliminar.ambos
      )
    },

    async confirmarEliminarProducto() {
      if (!this.productoAEliminar?.uuid) return

      const payload = {
        productoUuid: this.productoAEliminar.uuid,
        eliminarAuditoria:
          this.opcionesEliminar.auditoria || this.opcionesEliminar.ambos,
        eliminarIteracion:
          this.opcionesEliminar.iteracion || this.opcionesEliminar.ambos,
      }

      try {
        await this.$axios.$post('/auditorias/eliminarProducto', payload)

        await this.cargarProductos()
        await this.cargarProductosIteracion()

        this.dialogEliminarProducto = false
        this.productoAEliminar = null

        this.$store.commit('notification/show', {
          text: this.$t('bannerMessages.productProcessed'),
          color: 'success',
        })

      } catch (error) {
        this.$store.commit('notification/show', {
          text: this.$t('bannerMessages.productDeleteError'),
          color: 'error',
        })
      }
    },
  },
}
</script>
